import React from 'react';

const TimelineRespondIcon = ({ fill = 'grey' }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 14 14"
      xmlSpace="preserve"
      className="card-icon"
    >
      <title>Response to Issuer</title>
      <desc>Created with Sketch.</desc>
      <g id="Case-Details---New">
        <g id="Case-Details---Timeline" transform="translate(-862.000000, -2522.000000)">
          <g id="Timeline" transform="translate(255.000000, 777.000000)">
            <g id="Timeline-Items" transform="translate(277.000000, 107.000000)">
              <g id="Transferred" transform="translate(317.000000, 1620.000000)">
                <g id="Icon">
                  <g id="Avatar">
                    <path
                      id="Shape"
                      fill={fill}
                      d="M25.2,18H14.8c-1,0-1.8,0.8-1.8,1.8v7.9c0,1,0.8,1.8,1.8,1.8h2.6v2.3c0,0.2,0.2,0.3,0.3,0.3
                      c0.1,0,0.1,0,0.2-0.1l3.4-2.6h3.9c1,0,1.8-0.8,1.8-1.8v-7.9C27,18.8,26.2,18,25.2,18z M25.7,27.6c0,0.2-0.2,0.4-0.4,0.4h-4.4
                      l-0.4,0.3l-1.8,1.4v-1.6h-3.9c-0.2,0-0.4-0.2-0.4-0.4v-7.9c0-0.2,0.2-0.4,0.4-0.4h10.5c0.2,0,0.4,0.2,0.4,0.4V27.6z
                      M22.1,21.6c-0.1-0.1-0.3-0.1-0.4,0l-2.4,2.4l-1-1c-0.1-0.1-0.3-0.1-0.4,0l-0.6,0.6c-0.1,0.1-0.1,0.3,0,0.4l1.9,1.9
                      c0.1,0.1,0.3,0.1,0.4,0l3.2-3.2c0.1-0.1,0.1-0.3,0-0.4L22.1,21.6z"/>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default TimelineRespondIcon;
